import ChecklistItem from '@/views/checklist-item'
import ListChecklistItem from '@/views/checklist-item/list'
// import CreateChecklistItem from '@/views/checklist-item/create'
// import EditChecklistItem from '@/views/checklist-item/edit'

export default {
  path: 'checklist-item',
  component: ChecklistItem,
  redirect: 'checklist-item/list',
  name: 'Checklist item',
  children: [
    {
      path: 'list',
      name: 'checklist-item.list',
      component: ListChecklistItem
    }
    // {
    //   path: 'create',
    //   name: 'Create checklist-item',
    //   component: CreateChecklistItem
    // },
    // {
    //   path: 'edit/:checklist_item_id',
    //   name: 'Edit checklist-item',
    //   component: EditChecklistItem
    // },
  ]
}



// WEBPACK FOOTER //
// ./src/router/checklist-items/checklist-item.js